import { useState } from "react";

export function DraggableList({ items, onReorder, getKey, children }) {
  const [dragIdx, setDragIdx] = useState(null);
  return (
    <>
      {items.map((it, i) => (
        <div
          key={getKey(it)}
          draggable
          onDragStart={() => setDragIdx(i)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={() => {
            if (dragIdx === null || dragIdx === i) return;
            const a = [...items];
            const [m] = a.splice(dragIdx, 1);
            a.splice(i, 0, m);
            onReorder(a);
            setDragIdx(null);
          }}
          className={dragIdx === i ? "dragging" : ""}
        >
          {children(it, i)}
        </div>
      ))}
    </>
  );
}
